module.exports = __webpack_public_path__ + "img/moneyway-logo.3c3d0e6b.png";